var map = {
	"./Identify.svg": "gCdu",
	"./ad.svg": "a/7z",
	"./address.svg": "n0DW",
	"./browse.svg": "IFSK",
	"./call.svg": "1QFo",
	"./copy.svg": "QY/w",
	"./crown.svg": "h4ZH",
	"./erji.svg": "A7c7",
	"./eth-usdt.svg": "3mr+",
	"./exit.svg": "JoLo",
	"./headset.svg": "ywog",
	"./heart.svg": "cGLG",
	"./hot.svg": "E5QA",
	"./info.svg": "0sAL",
	"./message.svg": "J/b6",
	"./money.svg": "n+01",
	"./new.svg": "hOiy",
	"./newurl.svg": "i8Yp",
	"./noheart.svg": "lCZm",
	"./pay1.svg": "MQvn",
	"./poker.svg": "ny6R",
	"./proxy.svg": "N1JS",
	"./publish.svg": "yypv",
	"./report.svg": "oYft",
	"./rule.svg": "Jl9E",
	"./seeuser.svg": "+IgR",
	"./sex.svg": "aAHn",
	"./speaker.svg": "dM47",
	"./svg-1.svg": "2KNJ",
	"./time.svg": "rB5f",
	"./today.svg": "7Nwi",
	"./trc.svg": "B2d3",
	"./tui.svg": "Jtga",
	"./user-add.svg": "z2ri",
	"./user-management.svg": "NsVU",
	"./user.svg": "0MPP",
	"./vip.svg": "OyYz",
	"./vipfont.svg": "vHpU",
	"./wait.svg": "dEhc",
	"./warring.svg": "ac9V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lALy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"icon-[name]"} .svg$
// module id = lALy
// module chunks = 1